// extracted by mini-css-extract-plugin
export default {"root":"style_root__ON30H","root__ordering":"style_root__ordering__s4nOQ"};